import ConfirmDialogHost from "@/components/ConfirmDialog";
import { AssistantTaskProvider } from "@/assistant/AssistantTaskContext";
import { DashboardProvider } from "@/context/DashboardContext";
import { DeployProgressProvider } from "@/context/DeployProgressContext";
import DashboardShell from "@/layout/DashboardShell";
import AccountShell from "@/account/AccountShell";
import LoginPage from "@/auth/LoginPage";

function appPath(): string {
  return (typeof window !== "undefined" ? window.location.pathname : "").replace(/\/+$/, "") || "/";
}

function isLoginPath(path: string): boolean {
  return path === "/dashboard/login" || path === "/dashboard/signup" || path === "/login";
}

function DashboardApp() {
  return (
    <DashboardProvider>
      <DeployProgressProvider>
        <AssistantTaskProvider>
          <ConfirmDialogHost />
          <DashboardShell />
        </AssistantTaskProvider>
      </DeployProgressProvider>
    </DashboardProvider>
  );
}

function AccountApp() {
  return (
    <DashboardProvider>
      <AssistantTaskProvider>
        <ConfirmDialogHost />
        <AccountShell />
      </AssistantTaskProvider>
    </DashboardProvider>
  );
}

export default function App() {
  const path = appPath();
  if (path === "/" || path === "") {
    if (typeof window !== "undefined") {
      const dest = "/dashboard/login";
      if (window.location.pathname !== dest) {
        window.location.replace(dest);
        return null;
      }
    }
    return <LoginPage />;
  }
  if (isLoginPath(path)) {
    return <LoginPage />;
  }
  if (path === "/dashboard/account") {
    return <AccountApp />;
  }
  return <DashboardApp />;
}
